export type { BadgeProps } from './Badge'
export { Badge, BadgeSize, BadgeVariant } from './Badge'
